
<template>
  <v-form ref="form" lazy-validation>
    <v-row class="pa-5">
      <v-col cols="12">
         <v-autocomplete 
           v-model="account.bank_id" 
           prepend-icon="mdi-wallet"
           :readonly="read_only"
           :rules="[...required]"
           :items="allBanks" 
           label="Banco" item-text="attributes.name" 
           item-value="attributes.id" hide-no-data>
           <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
         </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-radio-group  v-model="account.current_account" row :readonly="read_only">
          <v-radio label="Conta Corrente" :value="true"></v-radio>
          <v-radio label="Conta Poupança" :value="false"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="8">
        <v-text-field :readonly="read_only" :rules="[...required]" v-model="account.name"
        label="Nome do Titular" prepend-icon="mdi-account-circle"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field :readonly="read_only" :rules="[...required]" v-model="account.agency"
         label="Agência" v-mask="'###############'" prepend-icon="mdi-numeric"></v-text-field>
      </v-col>
      <v-col cols="12" md="8">
        <v-text-field :readonly="read_only" :rules="[...required]" v-model="account.number"
          label="Número da conta" prepend-icon="mdi-credit-card"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field :readonly="read_only" :rules="[...required]" v-model="account.digit"
        label="Dígito" v-mask="'##'" prepend-icon="mdi-minus"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-if="!only_cpf" :readonly="read_only" :rules="[...required,...cnpj]" v-model="account.CNPJ"
         label="CNPJ" v-mask="'##.###.###/####-##'" prepend-icon="mdi-clipboard-account"></v-text-field>
        <v-text-field v-if="only_cpf" :rules="[...required, ...cpf]" v-model="account.CPF" :readonly="read_only"
         label="CPF Titular" prepend-icon="mdi-clipboard-account" v-mask="'###.###.###-##'"></v-text-field>
      </v-col>
     </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import validations from '@/mixins/validations.js'

export default {
  name: 'BankAccountForm',
  mixins: [ validations ],
  props:{
    account:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    },
    only_cpf:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    getData() {
      this.getBanks()
    },
    validate(){
      return this.$refs.form.validate()
    },
    ...mapActions({
      getBanks: 'Bank/index',
    })
  },
  computed: {
    ...mapState({
      allBanks: state => state.Bank.allBanks,
    })
  },
  mounted(){
    this.getData()
  },
}
</script>
